import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerV2InitialState, basedDataReducerV2 } from 'redux/base-reducer-v2';

import { IForward, IForwardModal } from '../types/eecs-forwards.types';

export interface ForwardInitialState extends BaseDataReducerV2InitialState<IForward> {
  selectedForward: IForward | null;
  currentModal: IForwardModal | null;
}

const { initialState, AC, reducer, thunks } = basedDataReducerV2<IForward, ForwardInitialState>('eecs-forward');

export const eecsForwardInitialState: ForwardInitialState = {
  ...initialState,
  perPage: 25,
  selectedForward: null,
  currentModal: null,
};

export const eecsForward = createSlice({
  name: 'eecsForward',
  initialState: eecsForwardInitialState,
  reducers: {
    setSelectedForward: (state, action: PayloadAction<IForward | null>) => {
      state.selectedForward = action.payload;
    },
    setForwardModal: (state, action: PayloadAction<IForwardModal | null>) => {
      state.currentModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as ForwardInitialState, action);
    });
  },
});

export const EecsForwardAC = AC;
export const onEecsForwardSort = thunks.onSort;
export const onEecsForwardFilter = thunks.onFilter;
export const clearEecsForwardFilters = AC.clearFilters;
export const setEecsForwardCurrentPage = AC.setCurrentPage;

export const { setForwardModal, setSelectedForward } = eecsForward.actions;
